// extracted by mini-css-extract-plugin
export default {"sortableBlockList":"sortableBlockList--QsHZHQJiOS","disabled":"disabled--G6bSSDFTya"};